// extracted by mini-css-extract-plugin
export default {"Delete":"authorizedSystemList_Delete__Qzq-i"};